import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ItemService } from '../../../../core/services/item.service';

@Component({
  selector: 'app-add-edit-item-popup',
  templateUrl: './add-edit-item-popup.component.html',
  styleUrls: ['./add-edit-item-popup.component.scss'],
})
export class AddEditItemPopupComponent implements OnInit {
  @Input() visibleItemPopup: boolean | undefined;
  @Input() userId: string | undefined;
  @Output() addItemOnChange: EventEmitter<any> = new EventEmitter();
  saveJobLoading = false;
  loading = false;
  name = '';
  disableSaveBtn = false;
  items: any;
  doesNameExists = false;

  constructor(
    private messageService: MessageService,
    private itemService: ItemService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.getItems();
  }

  closeJobDialog(onChange: boolean, data?:any): void {
    if (onChange) {
      this.addItemOnChange.emit({type:'save',...data});
      this.visibleItemPopup = false;
    } else {
      this.addItemOnChange.emit({type:'exit'});
      this.visibleItemPopup = false;
    }
  }

  saveItemData() {
    this.confirmationService.confirm({
      key: 'visibleConfirmStatusChange',
      message: `Are you sure you want to add ${this.name}  item type?`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.saveJobLoading = true;

        const payload = {
          name: this.name,
        };

        this.itemService.createItem(payload).subscribe({
          next: value => {
            this.saveJobLoading = false;
            this.closeJobDialog(true, value);
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Job has been updated!',
            });
          },
          error: error => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${
                error?.error?.message ? error?.error?.message : 'Error'
              }`,
            });
            this.closeJobDialog(false);
          },
        });
      },
      reject: () => {},
    });
  }

  getItems(): void {
    this.loading = true;

    this.itemService.getItems().subscribe({
      next: value => {
        this.loading = false;
        this.items = value;
      },
      error: error => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error?.error?.message ? error?.error?.message : 'Error'}`,
        });
        this.closeJobDialog(false);
      },
    });
  }

  nameOnChange(data: string) {
    if (this.checkItemNameExists(data)) {
      this.disableSaveBtn = false;
      this.doesNameExists = true;
    } else {
      this.disableSaveBtn = true;
      this.doesNameExists = false;
    }
  }

  checkItemNameExists(typed: string) {
    const typedLower = typed.toLowerCase();
    return this.items.some(
      (item: any) => item.name.toLowerCase() === typedLower
    );
  }
}
